import TimeTableDetail from '@/controllers/timetable/timetable-detail.js';
import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import axios from "axios";
import CONFIG from "@/assets/js/config.js";

export default {
  extends: TimeTableDetail,
  name: "timetableDetail",
  components: {
    MainLayout,
    Loading
  },

  data() {
    return {
      isLoading: false,
      noDataMsg: CONFIG.NO_DATA_EXIST,
      class_name: "",
      academic_year: 0,
      timeTableData: [],
      days: [],
      time: [],
    };
  },

  computed: {
    timetableDataMap() {
      const timetableMap = {};
      if (Array.isArray(this.timeTableData)) {
        this.timeTableData.forEach(item => {
          timetableMap[`${item.day_meta_id}${item.time_meta_id}`] = {
            subject_name: item.subject_name,
            teacher_name: item.teacher_name
          };
        });
      }
      return timetableMap;
    }
  },

  methods: {
    getTimeTableDetail() {
      this.isLoading = true;
      axios.get("/timetable/detail/" + this.$route.params.id)
        .then(response => {
          if (response && response.data && response.data.status === 200 && response.data.data) {
            this.timeTableData = response.data.data.timetable;
            this.class_name = response.data.data.class_name;
            this.academic_year = response.data.data.period_name;
            this.days = response.data.data.days;
            this.time = response.data.data.times;
          }
          this.isLoading = false;
        }) .catch(error => {
          if (error.response && error.response.status === 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error("Timetable Detail Error:", error.response?.data || error.message);
          }
          this.isLoading = false;
        });
    },

    // Override getTimetableMeta to prevent unnecessary API calls
    getTimetableMeta() {}
  },

  mounted() {
    this.isLoading = true;
    this.getTimeTableDetail();
  },
};
